import './index.css';
import '@/styles/global.scss';
import '@/styles/desktop.scss';

import { Outlet, useLocation } from '@modern-js/runtime/router';
import { Provider } from '@modern-js/runtime/model';
import { Helmet } from '@modern-js/runtime/head';
import { useEffect } from 'react';
import { GlobalProvider } from './globalProvider';
import { UserAuthProvider } from './auth';
import { DesktopThemeProvider } from '@/context/desktopThemeContext';
import { initializeDesktopTheme } from '@/utils/desktopTheme';
import { getSystem } from '@/utils';
import { getMeetingEnvByHostname } from '@/utils/meetingEnv';

if (typeof window !== 'undefined' && getSystem() === 'pc' && !window.location.pathname.startsWith('/test-') && !window.location.pathname.startsWith('/h5')) {
  initializeDesktopTheme();
}

const getMobileRootUrl = () => {
  const env = getMeetingEnvByHostname(window.location.hostname);
  return {
    development: 'https://meeting-mobile.hkgai.net',
    test: 'https://meeting-mobile-test.hkgai.org',
    production: 'https://meeting-mobile.hkgai.org',
  }[env];
};

export default function Layout() {
  const systemInfo = getSystem();
  const isPc = systemInfo === 'pc';
  const location = useLocation();
  const redesignEnabled = isPc && !location.pathname.startsWith('/test-') && !location.pathname.startsWith('/h5');

  return (
    <>
      <Helmet bodyAttributes={{ class: `${isPc ? 'my-pc' : 'my-h5'}${redesignEnabled ? ' desktop-redesign' : ''}` }}>
        <title>HKMeeting</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <meta httpEquiv="Expires" content="0" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="screen-orientation" content="portrait" />
        <meta name="full-screen" content="true" />
        <meta name="x5-fullscreen" content="true" />
        <meta name="x5-orientation" content="portrait" />
        <meta name="360-fullscreen" content="true" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta httpEquiv="Cache-Control" content="no-siteapp" />
      </Helmet>

      <Provider>
        <DesktopThemeProvider enabled={redesignEnabled}>
          <GlobalProvider desktop={redesignEnabled}>
            <UserAuthProvider>
              <>
                <Outlet />
              </>
            </UserAuthProvider>
          </GlobalProvider>
        </DesktopThemeProvider>
      </Provider>
    </>
  );
}
